// @flow

import { useController } from 'react-hook-form';
import { TextField as ReshapedTextField, type TextFieldProps } from 'reshaped';

import { FieldWrapper } from './FieldWrapper';
import type { FieldProps } from './types';

export type Props = {
  ...FieldProps<TextFieldProps>,
  name: string,
  /** Node for inserting text content before the text field value */
  prefix?: React.Node,
};

export function TextField({
  name,
  label,
  help,
  prefix,
  disabled,
  control,
  rules,
  inputProps,
  inputAttributes,
  onChange,
  ...extraProps
}: Props): React.MixedElement {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  return (
    <FieldWrapper
      fieldState={fieldState}
      label={label}
      help={help}
      {...extraProps}
    >
      {/* $FlowFixMe[incompatible-type] */}
      <ReshapedTextField
        name={field.name}
        value={field.value}
        onBlur={field.onBlur}
        prefix={prefix}
        disabled={disabled}
        onChange={({ event }) => field.onChange(event)}
        inputAttributes={{
          ...inputAttributes,
          ref: field.ref,
          // size="large" not working
          style: { height: 'revert' },
        }}
        size="large"
        {...inputProps}
      />
    </FieldWrapper>
  );
}
